import { Subject, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ITableItem } from './models/ITableItem';

@Injectable({ providedIn: 'root' })
export class ItemObserver<T extends ITableItem> {

  private readonly itemsUpdatedSubject = new ReplaySubject<T[]>(1);
  readonly itemsUpdated$ = this.itemsUpdatedSubject.asObservable();

  private readonly itemsRemovedSubject = new Subject<number[]>();
  readonly itemsRemoved$ = this.itemsRemovedSubject.asObservable();

  updateItem(item: T) {
    this.itemsUpdatedSubject.next([item]);
  }

  updateItems(items: T[]) {
    this.itemsUpdatedSubject.next(items);
  }

  removeItem(id: number) {
    this.itemsRemovedSubject.next([id]);
  }

  removeItems(ids: number[]) {
    this.itemsRemovedSubject.next(ids);
  }
}
